import React, { useState, useEffect } from "react";
import { CreateSponsor, FetchProductsApi } from "../../ApiCalls/AddProducts";
// import { BASE_URL } from "../../constant/api";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import { USER_URL } from "../../constant/api";

const SellerSponsorAdd = () => {
  const [title, setTitle] = useState("");
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [bannerFile, setBannerFile] = useState(null);
  const [fetchedProducts, setFetchedProducts] = useState([]);
  const [sponsoredProducts, setSponsoredProducts] = useState([]);
  const [bannerPackages, setBannerPackages] = useState([]);
  const [selectedBannerPackage, setSelectedBannerPackage] = useState(null);
  const [bannerPackagesLoading, setBannerPackagesLoading] = useState(true);
  const navigate = useNavigate();
  const fetchAdminBannerPackages = async () => {
    try {
      const response = await USER_URL.get(
        `/products/seller/packages/?promotion_type=Sponsored`,
      );
      console.log("Banner Packages Response:", response.data);
      setBannerPackages(response.data.Data);
      setBannerPackagesLoading(false);
    } catch (error) {
      console.error("Error fetching banner packages:", error.message || error);
      toast.error("Failed to fetch banner packages!");
    }
  };
  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const products = await FetchProductsApi();
        setFetchedProducts(products.Data);
      } catch (error) {
        console.error("Error fetching products:", error);
      }
    };
    fetchAdminBannerPackages();
    fetchProducts();
  }, []);

  const addToSponsored = (product) => {
    if (!sponsoredProducts.some((p) => p.id === product.id)) {
      const updatedList = [...sponsoredProducts, product];
      setSponsoredProducts(updatedList);
      setFetchedProducts((prev) => prev.filter((p) => p.id !== product.id));
    }
  };
  const removeFromSponsored = (productId) => {
    const removedProduct = sponsoredProducts.find((p) => p.id === productId);
    if (!removedProduct) return;

    setSponsoredProducts(sponsoredProducts.filter((p) => p.id !== productId));
    setFetchedProducts((prev) => [...prev, removedProduct]);
  };
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setBannerFile(file);
    }
  };

  const handleCreate = async () => {
    try {
      if (!selectedBannerPackage) {
        toast.warn("Please select a banner package.");
        return;
      }
      if (!title) {
        toast.warn("Please enter a title.");
        return;
      }
      if (!startDate) {
        toast.warn("Please select a start date.");
        return;
      }

      if (sponsoredProducts.length === 0) {
        toast.warn("Please add at least one sponsored product.");
        return;
      }

      const formData = new FormData();
      formData.append("title", title);
      formData.append("start_date", startDate);
      // formData.append("end_date", endDate);
      formData.append("package", selectedBannerPackage.id);

      if (bannerFile) {
        formData.append("sponsored_banner", bannerFile);
      }

      // Append each sponsored product in the format: sponsored_products[index]product
      sponsoredProducts.forEach((product, index) => {
        formData.append(`sponsored_products[${index}]product`, product.id);
      });

      console.log("Sending data:", Object.fromEntries(formData.entries()));

      // Send the data to the backend
      await CreateSponsor(formData);
      toast.success("Sponsor Created successfully!");
      // navigate('/seller/offer_brand/sponsored')
      // Reset state after successful submission
      setTitle("");
      setStartDate(null);
      setEndDate(null);
      setBannerFile(null);
      setSponsoredProducts([]);
      setSelectedBannerPackage(null);
      navigate("/seller/offer_brand/sponsored");
      // Refetch products to restore the list
      const products = await FetchProductsApi();
      setFetchedProducts(products.Data);

    } catch (error) {
      console.error("Error creating sponsor:", error.response?.data || error);
      toast.error("Failed to create sponsor. Please try again.");
    }
  };

  return (
    <div className="container mx-auto px-4 py-6">
      <div className="mb-5 mt-5">
        <h2 className="mb-4 text-center text-3xl font-medium text-brand-primary">
          Pick Your Banner Package
        </h2>
        {bannerPackagesLoading ? (
          <div>Loading...</div>
        ) : (
          <div className="flex w-full flex-wrap items-center justify-around gap-2">
            {bannerPackages.map((item) => (
              <div
                key={item.id}
                className={`flex w-full cursor-pointer flex-col items-center justify-center rounded-lg border-2 p-4 text-center shadow-md transition duration-300 ease-in-out hover:shadow-lg md:w-[300px] ${
                  selectedBannerPackage?.id === item.id
                    ? "border-green-600 bg-green-50"
                    : "border-gray-300 bg-white"
                }`}
                onClick={() => setSelectedBannerPackage(item)}
              >
                <div>
                  <h3 className="text-lg font-semibold">{item.name}</h3>
                  <p className="text-sm text-gray-600">Period: {item.period}</p>
                  <p className="text-sm text-gray-600">
                    Duration: {item.duration_days} day(s)
                  </p>
                  <p className="text-sm text-gray-600">Price: ₹{item.price}</p>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
      <h2 className="mb-5 text-center text-2xl font-medium">
        Create New Sponsor
      </h2>
      <div className="mb-6 flex w-full items-center gap-10">
        <div className="group relative h-44 w-1/2 overflow-hidden rounded-lg bg-slate-100 shadow-md">
          <input
            type="file"
            className="absolute inset-0 z-30 cursor-pointer opacity-0"
            onChange={handleFileChange}
          />
          {bannerFile ? (
            <img
              src={URL.createObjectURL(bannerFile)}
              alt="Sponsor Banner"
              className="h-full w-full object-cover"
            />
          ) : (
            <div className="flex h-full items-center justify-center bg-gray-200 text-gray-500">
              No Banner Selected
            </div>
          )}
        </div>
        <div className="flex w-1/3 flex-col space-y-2">
          <label className="text-lg font-medium text-brand-primary">
            Title
          </label>
          <input
            type="text"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            className="rounded-lg border border-black p-2"
          />
        </div>
        <div className="flex flex-col space-y-2">
          <label className="text-lg font-medium text-brand-primary">
            Start Date
          </label>
          <input
            type="date"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
            className="rounded-lg border border-black p-2"
          />
        </div>
        <div className="flex flex-col space-y-2">
          <label className="text-lg font-medium text-brand-primary">
            End Date
          </label>
          <input
            type="date"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
            className="rounded-lg border border-black p-2"
          />
        </div>
      </div>
      <div className="text-right">
        <button
          className="rounded-lg bg-green-500 px-6 py-2 text-white hover:bg-green-600"
          onClick={handleCreate}
        >
          Create Sponsor
        </button>
      </div>
      <div>
        {sponsoredProducts.length === 0 ? (
          <div className="py-4 text-center text-gray-500">
            No products added yet
          </div>
        ) : (
          sponsoredProducts.map((product, index) => (
            <div
              key={product.id}
              className="grid grid-cols-[4rem,2fr,2.5fr,1.5fr,1.5fr,5fr] p-2 text-gray-700"
            >
              <div className="text-center">{index + 1}</div>
              <div className="text-center">{product.product_code}</div>
              <div className="text-center">{product.name}</div>
              <div className="text-center">{product.stock}</div>
              <div className="text-center">{product.price}</div>
              <div className="text-center">
                <button
                  className="rounded-lg bg-red-500 px-4 py-2 text-white"
                  onClick={() => removeFromSponsored(product.id)}
                >
                  Remove
                </button>
              </div>
            </div>
          ))
        )}
      </div>
      <div className="border-t"></div>
      {fetchedProducts.map((product, index) => (
        <div
          key={product.id}
          className="grid grid-cols-[4rem,2fr,2.5fr,1.5fr,1.5fr,5fr] p-2 text-gray-700"
        >
          <div className="text-center">{index + 1}</div>
          <div className="text-center">{product.product_code}</div>
          <div className="text-center">{product.name}</div>
          <div className="text-center">{product.stock}</div>
          <div className="text-center">{product.price}</div>
          <div className="text-center">
            <button
              className="rounded-lg bg-blue-500 px-4 py-2 text-white"
              onClick={() => addToSponsored(product)}
            >
              Add to Sponsored
            </button>
          </div>
        </div>
      ))}
    </div>
  );
};

export default SellerSponsorAdd;
